@if (isDevMode) {
  <article class="container">
    <h2>Contentblok {{ block().blockType }}</h2>
    <p>Blok met type {{ block().blockType }} is nog niet ontwikkeld...</p>

    <pre>{{ block() | json }}</pre>
  </article>
}
